// extracted by mini-css-extract-plugin
export default {"istcontainer":"Ayurveda_istcontainer__pBfYS","featuredhbs":"Ayurveda_featuredhbs__sf3J0","Ashwagandha":"Ayurveda_Ashwagandha__-UNJw"};